<template>
  <div class="home">
    <div
      v-if="!state.mobile"
      class="content desktop">
      <map-grid
        @changeModeView="changeModeView"
        @mobileDetailView="mobileDetailView"
        :enable="state.interactive"
        :viewMode="state.viewMode"
      />
      <div v-if="!state.loading">
        <map-nav
          v-if="state.viewMode !== 3"
          @activecompass="changeModeView(3)" 
        />
      </div>

      <div class="intro" v-if="state.loading">
        <intro @intro-done="introCompleteHandle" />
      </div>
    </div>


    <div  v-if="state.mobile" class="content mobile">
      <mobile-view @changeModeView="changeModeView" @intro-done="introCompleteHandle" />
    </div>

    <!--  -->

    <audio-comp :detail="state.viewMode === 2 ? true : false" :start="!state.loading" />
    
  </div>
</template>

<script>
// @ is an alias to /src
import { onMounted, reactive } from '@vue/composition-api'
// import { useLoadedAssets } from '@/use/useLoadedAssets.js'

export default {
  name: 'Home',
  metaInfo: {
    title: 'Sea of Life Long',
    titleTemplate: '%s | '
  },

  components: {
    'map-grid': () => import('@/components/Map.vue'),
    'map-nav': () => import('@/components/MapNav.vue'),
    'intro': () => import('@/components/Intro.vue'),
    'mobile-view': () =>  import('@/components/Mobile'),
    'audio-comp': () =>  import('@/components/elements/audio/'),
  },
  setup () {
    const state = reactive({
      loading: true,
      viewMode: 1,
      detail: '',
      mobile: false
    })

    const changeModeView = (mode) => {
      state.viewMode = mode
    }

    const introCompleteHandle = () => {
      state.loading = !state.loading
    }

    const mobileDetailView = (val) => {
      state.detail = val
    }

    const checkDesktopView = () => {
      return state.mobile = (window.innerWidth < 960) ? true : false
    }



    onMounted(() => {
      checkDesktopView()
      window.addEventListener('resize', checkDesktopView);
    })

    return {
      state,
      changeModeView,
      introCompleteHandle,
      mobileDetailView
    }

  }
}
</script>

<style lang="scss" scoped>
    .intro {
      position: fixed;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      z-index: 9999;
    }
</style>
